import styled from 'styled-components/macro';
import {
    Button,
    Checkbox,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Select,
    useToast
} from "@chakra-ui/react";
import {useState} from "react";
import {useModal} from "../store";
import PayWithCrypto from "./subscriptions/pay_with_crypto";
import PayWithCard from "./subscriptions/pay_with_card";
import RoleIndicator from "./role_indicator";
import {themecolors} from "../utils/themecolors";

const Save = styled.div``;
const Tier = styled.div``;
const TierHeading = styled.div``;
const Tiers = styled.div``;
const Disclaimer = styled.div``;

const PaymentMethod = styled.div``;
const PaymentTitle = styled.h2``;
const PaymentDescription = styled.div``;
const PaymentText = styled.div``;

const BasicPro = styled.div``;
const Pro = styled.div``;

const List = styled.div``;

const ReadMore = styled.div``;

const titles = [
    'Upgrade to Pro',
    'Your Contribution',
    'Payment Method',
    'Payment Cycle'
]

const ProSubscribe = styled(({className, onClose}) => {

    const [tier, setTier] = useState('');
    const [price, setPrice] = useState(false);

    const [length, setLength] = useState(1);

    const modal = useModal();

    const [paymentMethod, setPaymentMethod] = useState("creditCard");
    const [page, setPage] = useState(1);
    const handleContinue = async () => {

        if (page === 2 && (price < 6.99 || price > 500)) return;

        if (paymentMethod === "cryptocurrency" && page < 4 || page < 3) {
            setPage(page + 1);
        } else {
            onClose();
            if (paymentMethod === "creditCard") {
                modal.open(PayWithCard, {type: 'subscription', tier: tier === 'basic' ? 1 : 2, length, overridePrice: price});
            } else if (paymentMethod === "cryptocurrency") {
                modal.open(PayWithCrypto, {type: 'subscription', tier: tier === 'basic' ? 1 : 2, length, subscriptionPrice: price});
            }
        }
    }

    const toast = useToast();
    const handlePaymentMethod = (value) => {
        if (value === paymentMethod) return;
        toast({
            title: `Sorry, this is currently unavailable.`,
            status: 'error',
            isClosable: true,
        });
        // setPaymentMethod(value);
    }

    return (
        <Modal
            isOpen
            onClose={onClose}
            size={page === 1 || page === 2 || page === 3 || page === 4 ? 'lg' : 'xl'}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>{titles[page-1]}</ModalHeader>
                <ModalCloseButton/>
                <ModalBody pb={6} className={className}>
                    {page === 1 &&
                        <>
                            <p>Contribute $6.99+ per month to support the platform and to receive Pro.</p>

                            <List>
                                <p>• help us continue to build</p>
                                <p>• get the <RoleIndicator proTier={2} /> badge</p>
                                <p>• go ad-free</p>
                                <p>• receive 1 award credit per month</p>
                                <ReadMore>
                                    <a href={"https://help.scored.co/knowledge-base/about-scored-pro/"}>
                                        • read more about Pro
                                    </a>
                                </ReadMore>
                            </List>

                        </>
                    }
                    {page === 2 &&
                    <>
                        <p>
                            Any monthly contribution of $6.99 or greater includes the Pro subscription.
                        </p>

                        <FormControl style={{marginTop: 16}}>
                            <FormLabel fontSize={15}>Your monthly contribution</FormLabel>
                            <Input type="number" value={price} onChange={(e) => setPrice(e.currentTarget.value)}/>
                        </FormControl>
                    </>
                    }
                    {page === 3 &&
                    <>
                        <PaymentMethod onClick={() => handlePaymentMethod('creditCard') }>
                            <Checkbox size={'lg'} isChecked={paymentMethod === "creditCard"}/>
                            <PaymentText>
                                <PaymentTitle>
                                    Credit Card
                                </PaymentTitle>
                                <PaymentDescription>
                                    Pay using a credit or debit card.
                                </PaymentDescription>
                            </PaymentText>
                        </PaymentMethod>
                        <PaymentMethod onClick={() => handlePaymentMethod('cryptocurrency') }>
                            <Checkbox size={'lg'} isChecked={paymentMethod === "cryptocurrency"} />
                            <PaymentText>
                                <PaymentTitle>
                                    Cryptocurrency
                                </PaymentTitle>
                                <PaymentDescription>
                                    Pay with privacy, using a range of cryptocurrencies.
                                </PaymentDescription>
                            </PaymentText>
                        </PaymentMethod>
                    </>
                    }
                    {page === 4 && paymentMethod === "cryptocurrency" &&
                        <>
                            <p>
                                Since recurring billing isn't currently viable with cryptocurrency, would you consider paying a longer duration upfront?
                            </p>
                            <Select style={{marginTop: 12}} onChange={(e) => setLength(e.currentTarget.value)}>
                                <option value={1}>No - I'll pay monthly.</option>
                                <option value={3}>Quarterly (3 months - ${price * 3})</option>
                                <option value={6}>Bi-annually (6 months - ${price * 6})</option>
                                <option value={12}>Annually (12 months - ${price * 12})</option>
                            </Select>
                        </>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleContinue}>
                        Next
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
  font-size: 15px;
  ${List} {
    margin: 16px 4px;
  }
  ${Tiers} {
    margin: 16px 0 12px 0;
    display: flex;
    justify-content: space-evenly;
  }
  ${TierHeading} {
    font-weight: 500;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
  }
  ${TierHeading} label {
    margin-top: -1px;
    margin-right: 8px;
  }
  ${Tier} p {
    font-size: 13px;
    padding-bottom: 4px;
  }
  ${Tier} {
    cursor: pointer;
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#212222' : '#fbfbfb'};
    border-radius: 6px;
    margin-right: 8px;
    padding: 16px;
    flex: 1;
  }
  ${Tier}:last-of-type {
    margin-right: 0;
  }
  ${Disclaimer} {
    color: ${({theme}) => theme.color.name === 'dark' ? '#545454' : '#b6b6b6'};
    font-size: 14px;
  }
  ${Save} {
    margin-top: auto;
    background-color: rgb(56, 98, 250);
    text-align: center;
    padding: 12px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    color: ${({theme}) => themecolors.pure_white};
  }
  ${PaymentMethod} {
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? '#343536' : '#f2f2f2'};
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 8px;
    display: flex;
    cursor: pointer;
  }
  ${PaymentText} {
    padding-left: 16px;
  }
  ${PaymentDescription} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${PaymentTitle} {
    margin: 0 !important;
  }
  ${Pro}, ${BasicPro} {
    border-radius: 2px;
    padding: 2px 4px;
    font-size: 11px;
    margin-left: 6px;
  }
  ${Pro} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#90f2ff2e' : '#cdf2f7'};
    color: ${({theme}) => theme.color.name === 'dark' ? '#cfcfcf8c' : '#0a3c5e8c'};
  }
  ${BasicPro} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#9191911f' : 'rgb(219, 219, 219)'};
    color: ${({theme}) => theme.color.name === 'dark' ? '#b0b0b08c' : '#042c008c'};
  }
  ${ReadMore} {
    margin-bottom: 8px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_2};
  }
  @media only screen and (max-width: 780px) {
    ${Tiers} {
      flex-direction: column;
    }
    ${Tier} {
      max-width: initial;
      margin-right: 0;
      margin-bottom: 8px;
    }
  }
`;

export default ProSubscribe;
